import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community'

interface Props extends IFilterParams {
  children: React.ReactNode
}

const TextFilter = forwardRef<any, Props>((props, ref) => {
  const [filterText, setFilterText] = useState<string>('')

  // Expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => ({
    isFilterActive() {
      return filterText !== ''
    },

    doesFilterPass(params: IDoesFilterPassParams) {
      const { node } = params
      const { api, colDef, column, columnApi, context } = props
      const value = props.valueGetter({
        api,
        colDef,
        column,
        columnApi,
        context,
        data: node.data,
        getValue: (field) => node.data[field],
        node,
      })

      // Modify this to handle your string filtering logic
      return value.toString().toLowerCase().includes(filterText.toLowerCase())
    },

    getModel() {
      return this.isFilterActive() ? { value: filterText } : null
    },

    setModel(model: any) {
      setFilterText(model ? model.value : '')
    },
  }))

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log("Onchanse")
    setFilterText(event.target.value)
  }

  useEffect(() => {
    console.log("Filter changed")
    props.filterChangedCallback()
  }, [filterText])

  return (
    <div className="p-4 w-[200px]" style={{ padding: 4, width: 200 }}>
      <input
        type="text"
        value={filterText}
        onChange={onChange}
        placeholder="Enter text to filter..."
        style={{ width: '100%', padding: '8px', margin: '4px 0' }}
      />
    </div>
  )
})

TextFilter.displayName = 'TextFilter'

export default TextFilter;
